import { combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { Action } from 'redux';

import { tracklogApi } from 'ff/debrief/features/TracklogApi';
import { appSlice } from 'ff/debrief/features/AppSlice';
import { modalSlice } from 'ff/debrief/features/ModalSlice';
import { mapSlice } from 'ff/debrief/features/MapSlice';
import { chronoSlice } from 'ff/debrief/features/ChronoSlice';
import { statusSlice } from 'ff/debrief/features/StatusSlice';
import DebriefMapSettingPersistor from 'ff/debrief/features/DebriefMapSettingPersistor';
import debugSlice from 'ff/common/debugMode/debugSlice';

const rootReducer = combineReducers({
    appSlice: appSlice.reducer,
    modalSlice: modalSlice.reducer,
    mapSlice: mapSlice.reducer,
    chronoSlice: chronoSlice.reducer,
    statusSlice: statusSlice.reducer,
    [tracklogApi.reducerPath]: tracklogApi.reducer,
    debugSlice: debugSlice.reducer,
});

export function createStore(preloadedState: Partial<RootState> = {}) {
    return configureStore({
        preloadedState: preloadedState,
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware()
                .concat(tracklogApi.middleware)
                .concat(DebriefMapSettingPersistor.middleware),
    });
}

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore['dispatch'];

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action
>;
